export default __webpack_public_path__ + "static/media/E9Brendering.f68a403a.jpeg";